import { useFormik } from 'formik'
import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { addOrUpdateDefaultCategoryApi, cityByCountryApi, countryListApi, getDefaultCategoryListApi, updateDefaultCategoryApi } from '../../../../utils/ApiEndpointFunctions'
import { capitalizeWords } from '../../../../utils/HelperFuncitons'
import DeletedModal from '../../../common/Modal/DeletedModal'
import { categoryInitialValue, defaultCategoryValidationSchema } from '../../../common/Validation'
import { S3_URL } from '../../../../utils/BaseUrl'
import ImageViewModal from '../../../common/Modal/ImageViewModal'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import CommonTable from '../../../common/Table/CommonTable'
import ReactSelect from 'react-select';
import { useAdminContext } from '../../../../context/adminContext'


function DefaultCategoryRental() {
    const [loader, setLoader] = useState(true);
    const [addLoader, setAddLoader] = useState(false);
    const [tableData, setTableData] = useState([]);
    const [selectedId, setSelectedId] = useState();
    const [selectedImg, setSelectedImg] = useState("")
    const DefaultCategoryModalId = "DefaultCategoryModal"
    const deleteModalId = "categoryDeleteModal"
    const imageViewModalId = "imageViewModalId"
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const rentalVehicleType = searchParams?.get("tab")
    const [countryOptions, setCountryOptions] = useState([])
    const [cityOptions, setCityOptions] = useState([])
    const { adminDetail } = useAdminContext();


    const filterCites = async (countryId) => {
        try {
            const res = await cityByCountryApi("", countryId)
            if (res.status === 200) {
                let cityOption = res.data?.data?.map(ele => ({ label: ele.name, value: ele.id }))
                setCityOptions(cityOption);
            }

        } catch (error) {
            console.log(error)
        }
    };

    const filterCountry = async (inputValue) => {
        try {
            const res = await countryListApi(inputValue)
            if (res.status === 200) {
                let cityOption = res.data?.data?.map(ele => ({ label: ele.name, value: ele.id }))
                setCountryOptions(cityOption);
            }
        } catch (error) {
            console.log(error)
        }
    };

    const handleCityChange = (city) => {
        searchFormik.setFieldValue('cityId', city)
    }

    const handleCountryChange = (country) => {
        console.log(country, 'this is count')
        setCityOptions([])
        searchFormik.setFieldValue('countryId', country);
        searchFormik.setFieldValue('cityId', null);
        filterCites(country.value)
      }

    const getAllCategory = async () => {
        try {
            setLoader(true)
            const res = await getDefaultCategoryListApi("yiinoRental", rentalVehicleType, searchFormik.values?.countryId?.value, searchFormik.values?.cityId?.value)
            if (res.status === 200) {
                setTableData(res.data?.data)
            }
        } catch (error) {
            console.log(error)
        }
        setLoader(false)
    }

    const handleSubmit = async (values) => {
        try {
            setAddLoader(true)
            let payload = JSON.parse(JSON.stringify(values));
            const res = await addOrUpdateDefaultCategoryApi(payload)
            if (res.status === 200) {
                toast.success(capitalizeWords(res.data?.message))
                getAllCategory();
                document.getElementById(DefaultCategoryModalId).click();
                formik.resetForm();
            }
        } catch (error) {
            error.response ?
                toast.error(error.response?.data?.message) :
                toast.error("Something went wrong");
            console.log(error)
        }
        setAddLoader(false)
    }

    const deleteCategory = async () => {
        setAddLoader(true)
        try {
            const res = await updateDefaultCategoryApi({ id: selectedId, status: false })
            if (res.status === 200) {
                document.getElementById(deleteModalId).click();
                toast.success(capitalizeWords(res.data?.message))
                getAllCategory();
            }
        } catch (error) {
            console.log(error)
            error.response ?
                toast.error(error.response?.data?.message) :
                toast.error("Something went wrong");
        }
        setAddLoader(false)
    }

    const searchFormik = useFormik({
        initialValues: {
            countryId: adminDetail.role !== "superAdmin" && adminDetail.countryId ? { label: adminDetail.countryName, value: adminDetail.countryId } : null,
            cityId: null,
        },
    })

    const formik = useFormik({
        initialValues: categoryInitialValue,
        onSubmit: handleSubmit,
        validationSchema: defaultCategoryValidationSchema
    })

    const updatingValueHandler = (value) => {
        formik.setValues(value)
    };

    useEffect(() => {
    if (adminDetail?.countryId) {
      filterCites(adminDetail.countryId);
    }
  
    if (adminDetail?.role === "superAdmin") {
      filterCountry();
    }
  }, [adminDetail]);

    useEffect(() => {
        if(rentalVehicleType)
        getAllCategory();
    }, [rentalVehicleType, searchFormik.values])

    const headerData = [
        { name: "S.No.", className: "col", key: "index" },
        { name: "Category", className: "col", key: "category" },
        // { name: "Surge", className:"col", key:"surcharge" },
        { name: "Cancellation", className: "col", key: "cancellationFee" },
        { name: "Platform Fee(%)", className: "col", key: "platformFee" },
        { name: "Action", className: "col", key: "action" },
    ]

    const defaultCategoryTableData = tableData?.map((ele, index) => ({
        index: index + 1,
        category: (<>
            {ele.image && <div className="avatar avatar-xs align-middle me-2">
                <img
                    className="avatar-img rounded-circle"
                    src={!ele.image ? "/images/profiledp.png" : `${S3_URL}/${ele?.image}`}
                    alt="img"
                    data-bs-toggle="modal"
                    data-bs-target={`#${imageViewModalId}`}
                    style={{ cursor: 'pointer' }}
                    onClick={() => { setSelectedImg(!ele.image ? "/images/profiledp.png" : `${S3_URL}/${ele?.image}`) }}
                />
            </div>}
            <Link className='text-primary' to={`/partners/rentals/defaultCategory?op=update&id=${ele?.id}&rentalVehicleType=${rentalVehicleType}`}>{capitalizeWords(ele?.category)}</Link>
        </>),
        // surcharge: ele?.surcharge ?? "-",
        cancellationFee: ele?.cancellationFee ?? "-",
        platformFee: ele?.platformFee ?? "-",
        action: (
            <>
                <div className="dropdown">
                    <button
                        className=" border-0 bg-white"
                        type="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                    >
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="16"
                            height="16"
                            fill="currentColor"
                            className="bi bi-three-dots-vertical"
                            viewBox="0 0 16 16"
                        >
                            <path d="M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0z" />
                        </svg>
                    </button>
                    <ul
                        className="dropdown-menu"
                        style={{ zIndex: "1000" }}
                    >
                        <li className="dropdown-item">
                            <div
                                // data-bs-toggle="modal"
                                // data-bs-target={`#${DefaultCategoryModalId}`}
                                // onClick={() => { updatingValueHandler(ele) }}
                                onClick={() => { navigate(`/partners/rentals/defaultCategory?op=update&id=${ele?.id}&rentalVehicleType=${rentalVehicleType}`) }}
                                style={{ cursor: "pointer" }}
                            >
                                View / Edit
                            </div>
                        </li>

                        <li className="dropdown-item" >
                            <div
                                data-bs-toggle="modal"
                                data-bs-target={`#${deleteModalId}`}
                                onClick={() => { setSelectedId(ele?.id) }}
                                style={{ cursor: "pointer" }}
                            >
                                Delete
                            </div>
                        </li>
                    </ul>
                </div>
            </>
        )
    }))

    return (
        <><div className="d-flex justify-content-end flex-wrap align-items-center mt-3 mt-lg-0">
            <div style={{ display: "-webkit-inline-box" }}>
                <div className="position-relative d-flex gap-3 my-3">

                    <div className="d-flex align-items-center mb-3 gap-2">
                        <label htmlFor="city" className="form-label">Country</label>
                        <ReactSelect className='reactSelectMinWidth' isDisabled={adminDetail.role !== "superAdmin"} options={countryOptions} value={searchFormik?.values?.countryId} onChange={handleCountryChange} onBlur={searchFormik?.handleBlur} noOptionsMessage={() => 'No Countries Available'} />
                        {searchFormik?.touched?.countryId && searchFormik?.errors?.countryId ? (<div className='req-error'>{searchFormik?.errors?.countryId}</div>) : null}
                    </div>

                    <div className="d-flex align-items-center mb-3 gap-2">
                        <label htmlFor="city" className="form-label">City</label>
                        <ReactSelect className='reactSelectMinWidth' options={cityOptions} isDisabled={!searchFormik?.values?.countryId} value={searchFormik?.values?.cityId} onChange={handleCityChange} onBlur={searchFormik?.handleBlur} noOptionsMessage={() => 'No Cities Available'} />
                        {searchFormik?.touched?.cityId && searchFormik?.errors?.cityId ? (<div className='req-error'>{searchFormik?.errors?.cityId}</div>) : null}
                    </div>

                    <div>
                        <div>
                            <button
                                className="btn btn-primary"
                                onClick={() => { searchFormik.resetForm(); }}
                                disabled={!searchFormik?.values?.countryId}
                            >
                                Reset filter
                            </button>
                        </div>
                    </div>

                    <button
                        className="btn btn-primary"
                        // data-bs-toggle="modal"
                        // data-bs-target={`#${DefaultCategoryModalId}`}
                        // onClick={() => { formik.resetForm(); }}
                        onClick={() => { navigate(`/partners/rentals/defaultCategory?op=add&rentalVehicleType=${rentalVehicleType}&rentalVehicleType=${rentalVehicleType}`) }}
                    >
                        Add
                    </button>
                </div>
            </div>
        </div>
            <CommonTable headers={headerData} data={defaultCategoryTableData} loading={loader} />

            <DeletedModal
                modalId={deleteModalId}
                message={"this Category"}
                deletedHandler={deleteCategory}
                loader={addLoader}
            />
            <ImageViewModal imgUrl={selectedImg} modalId={imageViewModalId} />
        </>
    )
}

export default DefaultCategoryRental;